import NavbarLanding from "../components/NavbarLanding";
import FooterComponent from "../components/landingPages/FooterComponent";
import React from "react";

const LandingPageWidget = ({children}) => {
    return(
        <React.Fragment>
            <div id="main-navbar" className="fixed top-0 w-full z-50 transition-all duration-500">
                <NavbarLanding />
            </div>
            <div className="pt-20">
                <div className="flex flex-col">
                    {children}
                </div>
            </div>
            <FooterComponent />
        </React.Fragment>
    )
}
export default LandingPageWidget;